import React from "react";
import Account from "./Account";
import ChangePassword from "./ChangePassword";
import Document from "./Document";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
const MainProfile = () => {
  return (
    <>
      <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <div class="container-fluid">
          {/* <!-- <h6 class="font-weight-bolder mb-4">Add Source Masking Details.</h6> --> */}
          <div class="row">
            <div class="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div class="card mb-3 mt-4">
                <div class="card-header p-3 pt-2">
                  <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    {/* <i class="material-icons opacity-10">person</i> */}
                    {/* <PersonRoundedIcon className="person_2" />          */}

                    <PersonRoundedIcon
                    style={{
                      color: "white",
                      fontSize: "27px",
                    }}
                  />
                             </div>
                  <div class="pt-1 marginleft_0">
                    <p class="text-sm mb-0 text-capitalize fw-bold">
                      Profile Details
                    </p>
                  </div>
                </div>
                <div className="card-body">
                <div class="container">
                  <div class="row">
                    <div class="col-md-3 d-flex flex-column">
                    <div className="sidebar_1 h-100">
                      <ul
                        class="nav nav-tabs nav-tabs_1 d-block"
                        id="myTab"
                        role="tablist"
                      >
                        <li class="nav-item" role="presentation">
                          <button
                            class="nav-link active w-100 tabs_radius"
                            id="home-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#home"
                            type="button"
                            role="tab"
                            aria-controls="home"
                            aria-selected="true"
                          >
                            Account
                          </button>
                        </li>
                        {/* <li class="nav-item" role="presentation">
                          <button
                            class="nav-link w-100 tabs_radius"
                            id="profile-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#profile"
                            type="button"
                            role="tab"
                            aria-controls="profile"
                            aria-selected="false"
                          >
                            Documents
                          </button>
                        </li> */}
                        {/* <li class="nav-item" role="presentation">
                          <button
                            class="nav-link w-100 tabs_radius"
                            id="contact-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#contact"
                            type="button"
                            role="tab"
                            aria-controls="contact"
                            aria-selected="false"
                          >
                            Settings
                          </button>
                        </li> */}
                        <li className="nav-item" role="presentation">
                          <button
                            class="nav-link w-100 tabs_radius"
                            id="ContactDetails-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#ContactDetails"
                            type="button"
                            role="tab"
                            aria-controls="ContactDetails"
                            aria-selected="false"
                            // onClick={fetchContactDetails}
                          >
                            Change Password
                          </button>
                        </li>
                      </ul>
                      </div>
                    </div>
                    <div class="col-md-9">
                      <div class="tab-content" id="myTabContent">
                        <div
                          class="tab-pane fade show active"
                          id="home"
                          role="tabpanel"
                          aria-labelledby="home-tab"
                        >
                          <Account />
                        </div>
                        <div
                          class="tab-pane fade"
                          id="profile"
                          role="tabpanel"
                          aria-labelledby="profile-tab"
                        >
                          <Document />
                        </div>
                        <div
                          class="tab-pane fade"
                          id="contact"
                          role="tabpanel"
                          aria-labelledby="contact-tab"
                        ></div>
                        <div
                          class="tab-pane fade"
                          id="ContactDetails"
                          role="tabpanel"
                          aria-labelledby="ContactDetails-tab"
                        >
                          <ChangePassword />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default MainProfile;
